import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["indicator"]

  connect() {
    this._startY = 0
    this._pulling = false
    this._threshold = 80

    this._onTouchStart = this._onTouchStart.bind(this)
    this._onTouchMove = this._onTouchMove.bind(this)
    this._onTouchEnd = this._onTouchEnd.bind(this)

    this.element.addEventListener("touchstart", this._onTouchStart, { passive: true })
    this.element.addEventListener("touchmove", this._onTouchMove, { passive: false })
    this.element.addEventListener("touchend", this._onTouchEnd, { passive: true })
  }

  disconnect() {
    this.element.removeEventListener("touchstart", this._onTouchStart)
    this.element.removeEventListener("touchmove", this._onTouchMove)
    this.element.removeEventListener("touchend", this._onTouchEnd)
  }

  _onTouchStart(e) {
    // Only trigger if at the top of the scroll
    const scrollTop = this.element.scrollTop || window.scrollY || document.documentElement.scrollTop
    if (scrollTop > 5) return

    this._startY = e.touches[0].clientY
    this._pulling = true
  }

  _onTouchMove(e) {
    if (!this._pulling) return

    const y = e.touches[0].clientY
    const diff = y - this._startY

    if (diff < 0) {
      this._reset()
      return
    }

    // Prevent native scroll while pulling
    if (diff > 10) {
      e.preventDefault()
    }

    const progress = Math.min(diff / this._threshold, 1)
    const translateY = Math.min(diff * 0.4, 60)

    if (this.hasIndicatorTarget) {
      this.indicatorTarget.style.transform = `translateY(${translateY}px)`
      this.indicatorTarget.style.opacity = progress
      this.indicatorTarget.classList.toggle("pull-refresh--ready", progress >= 1)
    }
  }

  _onTouchEnd() {
    if (!this._pulling) return

    const indicator = this.hasIndicatorTarget ? this.indicatorTarget : null

    if (indicator && indicator.classList.contains("pull-refresh--ready")) {
      // Show loading state
      indicator.classList.add("pull-refresh--loading")
      indicator.style.transform = "translateY(40px)"

      // Reload via Turbo
      setTimeout(() => {
        Turbo.visit(window.location.href, { action: "replace" })
      }, 300)
    } else {
      this._reset()
    }

    this._pulling = false
  }

  _reset() {
    this._pulling = false
    if (this.hasIndicatorTarget) {
      this.indicatorTarget.style.transform = "translateY(0)"
      this.indicatorTarget.style.opacity = "0"
      this.indicatorTarget.classList.remove("pull-refresh--ready", "pull-refresh--loading")
    }
  }
}
